<template>
  <div>
    <the-navbar/>
    <rvdashboard/>
    <Footer/>
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import TheNavbar from "@/components/TheNavbar.vue";
import rvdashboard from "@/components/rvdashboard.vue";
export default {
  name: "Webapp",
  components: {
    Footer,
    TheNavbar,
    rvdashboard
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Webapp.vue